export default function EmergencyDiagnosis() {
  return (
    <section className="py-20 bg-[#F5F3EF]">
      <div className="max-w-6xl mx-auto px-6">
        {/* Title */}
        <div className="mb-12">
          <p className="text-sm text-gray-500 font-light mb-2">EMERGENCY CHECK</p>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#2C4A3E] leading-tight">
            내 건물도 양성화 대상일까?
            <br />
            <span className="text-3xl md:text-4xl">2026년 특별법 확정 가이드라인</span>
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {/* Card 1 */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center">
                <i className="ri-checkbox-circle-line text-5xl text-[#2C4A3E]"></i>
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">양성화 가능 대상</h3>
            <p className="text-gray-600 leading-relaxed text-sm">
              2024년 12월 31일 이전 완공, 165㎡ 이하 또는 지자체 조례 적용 시 330㎡까지
            </p>
          </div>

          {/* Card 2 */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center">
                <i className="ri-alert-line text-5xl text-[#D97642]"></i>
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">양성화 불가 대상</h3>
            <p className="text-gray-600 leading-relaxed text-sm">
              녹지지역 건축물, 주차장 확보 불가 근생빌라, 과도한 방 쪼개기
            </p>
          </div>

          {/* Card 3 */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center">
                <i className="ri-coins-line text-5xl text-[#5C4033]"></i>
              </div>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">이행강제금 5회분 납부</h3>
            <p className="text-gray-600 leading-relaxed text-sm">
              체납액 포함 5회분 완납 시 합법화 승인, 평생 부과 종료
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
